import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Card, CardTitle, Col, FormGroup, Label, Modal, Row } from 'reactstrap';
import Select from 'react-select';
import { genericIndexedActions } from '../../../redux/actions/generics/GenericIndexedActions';
import { addonPriceService } from '../../../jwt/_services/configuration/addonPriceService';
import { currencyProvider } from '../../../providers/currencyProvider';
import { GenericButton } from '../../../components/buttons/customButtons';
import { TT_CLOSE, TT_SAVE } from '../../../components/i18n/toolTips';
import Separator from '../../../components/Separator';

export const AddonPriceForm = forwardRef((props, ref) => {
    const path = props.path;

    const [modal, setModal] = useState(false);
    const [item, setItem] = useState(null);
    const [addon, setAddon] = useState(null);

    const [fbDataBase, setFbDataBase] = useState(null);
    const [price, setPrice] = useState('');
    const [currency, setCurrency] = useState(null);
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [loadingCurrencies, setLoadingCurrencies] = useState(false);

    useEffect(() => {
        setLoadingCurrencies(true);
        currencyProvider
            .getOptions()
            .then((result) => {
                setCurrencyOptions(result || []);
                setLoadingCurrencies(false);
            })
            .catch(() => {
                setCurrencyOptions([]);
                setLoadingCurrencies(false);
            });
    }, []);

    useImperativeHandle(ref, () => ({
        showModal(_item, _addon, _fbDataBase) {
            setItem(_item || null);
            setAddon(_addon || null);
            setPrice(_item?.price || '');
            setFbDataBase(_fbDataBase || null);

            if (_item?.currency) {
                currencyProvider
                    .getItem(_item.currency?.id || _item.currency)
                    .then((data) => setCurrency(data))
                    .catch(() => setCurrency(null));
            } else {
                setCurrency(null);
            }

            setModal(true);
        },
    }));

    const closeModal = () => {
        setModal(false);
        setItem(null);
        setPrice('');
        setCurrency(null);
    };

    const onSubmit = () => {
        if (!currency || price === '' || price === null) return;

        const dataRequest = {
            fbDataBase,
            item: {
                price: parseFloat(price),
                currency: { id: currency?.idCurrency },
                addon: { id: addon?.id },
            },
        };

        if (item?.id) {
            dataRequest.item.id = item.id;
            genericIndexedActions.update(path, addonPriceService, item.id, dataRequest);
        } else {
            genericIndexedActions.save(path, addonPriceService, dataRequest);
        }

        closeModal();
    };

    return (
        <Modal isOpen={modal} toggle={closeModal} modalClassName="menu-modal-form">
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <h2 className="card-modal-title">
                        {item?.id ? 'Editar Precio' : 'Nuevo Precio'}
                    </h2>
                    <div className="float-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            onClick={onSubmit}
                        />
                        <GenericButton
                            style={'danger-secondary'}
                            icon={'fa-times'}
                            toolTip={TT_CLOSE}
                            permission={'search'}
                            onClick={closeModal}
                        />
                    </div>
                </CardTitle>

                <div className="p-4">
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label>Moneda (Currency)</Label>
                                <Select
                                    isLoading={loadingCurrencies}
                                    options={currencyOptions}
                                    value={currency}
                                    onChange={(selected) => setCurrency(selected)}
                                    placeholder="Selecciona una moneda..."
                                    classNamePrefix="select"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label>Precio</Label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="0.00"
                                    value={price}
                                    min={0}
                                    step="0.01"
                                    onChange={(e) => setPrice(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            </Card>
        </Modal>
    );
});

export default AddonPriceForm;
